import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, switchMap } from 'rxjs/operators';

import { FMFService } from '../../../../shared/services';
import { WindowRef } from '../../../../shared/services/window-ref';
import { LoadFMFScript } from '../../actions/index';

@Injectable()
export class FMFEffects {
  constructor(
    private readonly fmfService: FMFService,
    private readonly actions$: Actions,
    private readonly window: WindowRef,
  ) {}

  loadFMFScript$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoadFMFScript),
        filter(() => !this.window.nativeWindow.Cypress),
        switchMap(() => {
          return this.fmfService.init();
        }),
      ),
    { dispatch: false },
  );
}
